import axios from "axios";
import { SITE_URL } from "../../siteInfo/siteInfo";

export const FETCH_POSTS = "FETCH_POSTS";
export const FETCH_POST = "FETCH_POST";
export const FETCH_CATEGORY_POSTS = "FETCH_CATEGORY_POSTS";
export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const RECOMMENDED_POST = "RECOMMENDED_POST";
export const FETCH_BASICINFO = "FETCH_BASICINFO";
export const FETCH_ABOUTINFO = "FETCH_ABOUTINFO";
export const FETCH_SNSINFO = "FETCH_SNSINFO";

//テスト用URLどうするか考える。
const WP_CUSTOM_API_ENDPOINT = `${SITE_URL}/wp-json/custom/v0`;
const WP_API_ENDPOINT = `${SITE_URL}/wp-json/wp/v2`;

/**
 * サイトの基本情報を取得する。
 * ヘッダー情報
 * プロフィール情報
 */
export function fetchSiteBasicInfo() {
  return function (dispatch) {
    axios.get(`${WP_CUSTOM_API_ENDPOINT}/basicInfo`).then((response) => {
      dispatch({
        type: FETCH_BASICINFO,
        basicInfo: {
          site_title: response.data.site_title,
          site_url: response.data.site_url,
          site_img: response.data.site_img,
          description: response.data.description,
          recommend_posts: response.data.recommend_posts,
          header_info: response.data.header_info,
          profile_info: response.data.profile_info,
        },
      });
    });
  };
}

/**
 * Aboutページ(サイト運営者についてのページ)い表示する情報を取得する。
 */
export function fetchAboutInfo() {
  return function (dispatch) {
    axios.get(`${WP_CUSTOM_API_ENDPOINT}/aboutInfo`).then((response) => {
      dispatch({
        type: FETCH_ABOUTINFO,
        aboutInfo: response.data,
      });
    });
  };
}
/**
 * サイト運営者のSNS情報を取得する。
 */
export function fetchSnsInfo() {
  return function (dispatch) {
    axios.get(`${WP_CUSTOM_API_ENDPOINT}/snsInfo`).then((response) => {
      dispatch({
        type: FETCH_SNSINFO,
        snsInfo: response.data,
      });
    });
  };
}

/**
 * 引数に渡されたページの記事データを取得する
 * @param {*} pageNum
 */
export function fetchPosts(pageNum) {
  return function (dispatch) {
    axios
      .get(`${WP_API_ENDPOINT}/posts?_embed&page=${pageNum}`)
      .then((response) => {
        dispatch({
          type: FETCH_POSTS,
          postsData: {
            posts: response.data,
            totalPageNum: response.headers["x-wp-totalpages"],
            fetchPageNum: pageNum,
            //-1の場合カテゴリーは気にしない。
            categoryId: -1,
          },
        });
      });
  };
}
/**
 * 対象のカテゴリーの記事一覧を取得する。
 * @param {*} pageNum
 * @param {*} categoryId
 */
export function fetchCategoryPosts(pageNum, categoryId) {
  return function (dispatch) {
    axios
      .get(
        `${WP_API_ENDPOINT}/posts?_embed&page=${pageNum}&categories[]=${categoryId}`
      )
      .then((response) => {
        dispatch({
          type: FETCH_CATEGORY_POSTS,
          postsData: {
            posts: response.data,
            totalPageNum: response.headers["x-wp-totalpages"],
            fetchPageNum: pageNum,
            categoryId: categoryId,
          },
        });
      });
  };
}
// 対象のslugの記事を取得する。
export function fetchArticle(slug) {
  return function (dispatch) {
    axios
      .get(`${WP_API_ENDPOINT}/posts?_embed&slug=${slug}`)
      .then((response) => {
        dispatch({
          type: FETCH_POST,
          postsData: {
            posts: response.data,
            totalPageNum: response.headers["x-wp-totalpages"],
            fetchPageNum: -1,
            categoryId: -1,
          },
        });
      });
  };
}

/**
 * おすすめ記事を取得する。
 */
export function fetchRecommendedPosts(idList) {
  var url = `${WP_API_ENDPOINT}/posts?&_embed`;
  for (let i = 0; i < idList.length; i++) {
    url += `&include[]=${idList[i]}`;
  }
  console.log(url);
  return function (dispatch) {
    axios.get(url).then((response) => {
      dispatch({
        type: RECOMMENDED_POST,
        posts: response.data,
      });
    });
  };
}

/**
 * ブログのカテゴリーを全て取得する。
 */
export function fetchCategories() {
  return function (dispatch) {
    axios
      .get(`${WP_API_ENDPOINT}/categories/?per_page=100`)
      .then((response) => {
        dispatch({
          type: FETCH_CATEGORIES,
          categories: categoriesList(response.data),
        });
      });
  };
}

/**
 * タグの親子関係を整理した配列を返す。2階層まで対応。
 * @param {*} responseData
 */
function categoriesList(responseData) {
  var categories = [];
  try {
    for (var data of responseData) {
      if (data.parent === 0) {
        var parentCategory = {
          id: data.id,
          name: data.name,
          count: data.count,
        };
        categories.push(parentCategory);
      }
    }
    for (var parentData of categories) {
      var childCategoriesList = [];
      for (var chiledData of responseData) {
        if (parentData.id === chiledData.parent) {
          var childCategory = {
            id: chiledData.id,
            name: chiledData.name,
            count: chiledData.count,
          };
          childCategoriesList.push(childCategory);
        }
      }
      parentData["child"] = childCategoriesList;
    }
  } catch {
    return [];
  }

  return categories;
}
